import React from 'react'
import * as Styles from './BrowserMockup.module.css'

const BrowserMockup = ({ children, className }) => {
  return (
    <div className={`${Styles.browser} ${className || ''}`}>
      <div className={Styles.addressBar}>
        <div className="w-3 h-3 rounded-full border-2 border-red-500"></div>
        <div className="w-3 h-3 rounded-full border-2 border-yellow-400"></div>
        <div className="w-3 h-3 rounded-full border-2 border-green-400"></div>
      </div>

      <div>{children}</div>
    </div>
  )
}

export default BrowserMockup
